/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Notify_Discord_HintInputs */

const en_gd_notify_discord_hint = /** @type {(inputs: Gd_Notify_Discord_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a webhook in your Discord channel settings, then paste its URL here.`)
};

const id_gd_notify_discord_hint = /** @type {(inputs: Gd_Notify_Discord_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat webhook di setelan kanal Discord-mu, lalu tempel tautannya di sini.`)
};

/**
* | output |
* | --- |
* | "Create a webhook in your Discord channel settings, then paste its URL here." |
*
* @param {Gd_Notify_Discord_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_notify_discord_hint = /** @type {((inputs?: Gd_Notify_Discord_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Notify_Discord_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_notify_discord_hint(inputs)
	return en_gd_notify_discord_hint(inputs)
});